import { ApplicationConfig, inject, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { OFFICE_ADAPTER, OfficeAdapter } from './core/office/office-adapter';
import { RealOfficeAdapter } from './core/office/real-office-adapter';
import { SimHostState } from './core/office/sim-host-state';
import { SimOfficeAdapter } from './core/office/sim-office-adapter';

/**
 * Real adapter inside an Outlook host; simulator adapter everywhere else
 * (the `/#/sim` dev harness and plain-browser dev work).
 */
function officeAdapterFactory(): OfficeAdapter {
  const office = (globalThis as { Office?: { context?: { mailbox?: unknown } } }).Office;
  if (office?.context?.mailbox) return new RealOfficeAdapter();
  return new SimOfficeAdapter(inject(SimHostState));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withHashLocation()),
    { provide: OFFICE_ADAPTER, useFactory: officeAdapterFactory },
  ],
};
